import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { Reveal, Tag } from "./Reveal";
import { ASSETS } from "../../lib/assets";

const BADGES = [ASSETS.certs.iso9001, ASSETS.certs.iso14001, ASSETS.certs.iso45001];

export const Certifications = () => {
  const { t } = useLang();
  return (
    <section id="certifications" className="relative bg-brand-navy py-24 md:py-32 overflow-hidden" data-testid="certifications">
      <div className="absolute inset-0 opacity-20">
        <img src={ASSETS.bgNavyTexture} alt="" className="h-full w-full object-cover" loading="lazy" />
      </div>
      <div className="absolute inset-0 bg-brand-navy/60" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <Reveal className="lg:col-span-5">
            <Tag dark>{t.certs.tag}</Tag>
            <h2 className="mt-5 font-display font-semibold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              {t.certs.title}
            </h2>
            <p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed">{t.certs.subtitle}</p>
            <div className="mt-8 inline-flex items-center gap-3 rounded-full border border-white/15 bg-white/5 px-5 py-3">
              <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />
              <span className="font-condensed text-xs uppercase tracking-[0.12em] text-slate-300">Quality Austria · IQNet</span>
            </div>
          </Reveal>

          <div className="lg:col-span-7 grid sm:grid-cols-3 gap-4">
            {t.certs.items.map((c, i) => (
              <Reveal key={i} delay={i * 0.12}>
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ duration: 0.5 }}
                  className="h-full rounded-2xl bg-white p-6 flex flex-col items-center text-center shadow-lg"
                  data-testid={`cert-card-${i}`}
                >
                  <div className="flex-1 flex items-center justify-center py-2">
                    <img src={BADGES[i]} alt={`Certificazione ${c.code}`} loading="lazy" className="h-32 w-auto object-contain" />
                  </div>
                  <div className="mt-4 pt-4 border-t border-slate-100 w-full font-condensed text-xs uppercase tracking-[0.15em] text-brand-blue">
                    {c.label}
                  </div>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
        <Reveal delay={0.2}>
          <p className="mt-10 text-xs text-slate-500">{t.certs.verify}</p>
        </Reveal>
      </div>
    </section>
  );
};
